








import Vue from 'vue';

export default Vue.extend({
  name: 'PopOutSideBar',
  props: {
    sidebarOpen: { default: false },
    right: Boolean
  }
});
